export default class ChangePasswordDto {
    currentPassword:string;
    newPassword:string;
    repeatPassword:string;
}